import React from 'react';
import { formatCurrency } from '../utils/formatCurrency';
interface LineItemDetail {
  label: string;
  value: string;
}
interface LineItem {
  type: 'accommodation' | 'flight' | 'cruise';
  category: string;
  itemName: string;
  details: LineItemDetail[];
  unitFare: number;
  quantity: number;
  tax: number;
  discountAmount?: number;
  discountRate?: number;
  amount: number;
}
interface InvoiceLineItemsProps {
  items: LineItem[];
}
export function InvoiceLineItems({
  items
}: InvoiceLineItemsProps) {
  const formatDiscount = (amount: number, rate?: number) => {
    if (amount === 0) return '-';
    const amountStr = `-${formatCurrency(amount)}`;
    if (rate) {
      return `${amountStr} (${rate}%)`;
    }
    return amountStr;
  };
  return <div className="mb-4" data-id="element-604">
      {/* Table Header */}
      <div className="grid grid-cols-12 gap-4 pb-3 border-b-2 border-neutral-300 mb-4" data-id="element-605">
        <div className="col-span-5 text-xs font-semibold text-neutral-700 uppercase tracking-wide" data-id="element-606">
          Description
        </div>
        <div className="col-span-2 text-xs font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-607">
          Unit Price
        </div>
        <div className="col-span-1 text-xs font-semibold text-neutral-700 text-center uppercase tracking-wide" data-id="element-608">
          Qty
        </div>
        <div className="col-span-1 text-xs font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-609">
          Tax
        </div>
        <div className="col-span-1 text-xs font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-610">
          Discount
        </div>
        <div className="col-span-2 text-xs font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-611">
          Amount
        </div>
      </div>

      {/* Line Items */}
      {items.map((item, index) => <div key={index} className="border-b border-neutral-200 pb-5 mb-5 last:border-b-0" data-id="element-612">
          {/* Main Row */}
          <div className="grid grid-cols-12 gap-4 mb-3" data-id="element-613">
            <div className="col-span-5" data-id="element-614">
              <p className="text-sm text-neutral-900 mb-2" data-id="element-615">
                <span className="font-bold" data-id="element-616">{item.category}</span>
                {' – '}
                <span data-id="element-617">{item.itemName}</span>
              </p>

              {/* Nested Details - All inside Description column */}
              <div className="pl-3 border-l-2 border-neutral-200 space-y-0.5" data-id="element-618">
                {item.details.map((detail, detailIndex) => <div key={detailIndex} className="flex text-xs" data-id="element-619">
                    <span className="text-neutral-500 min-w-[120px] font-medium" data-id="element-620">
                      {detail.label}:
                    </span>
                    <span className="text-neutral-700" data-id="element-621">{detail.value}</span>
                  </div>)}
              </div>
            </div>
            <div className="col-span-2 text-right text-neutral-900 tabular-nums text-sm" data-id="element-622">
              {formatCurrency(item.unitFare)}
            </div>
            <div className="col-span-1 text-center text-neutral-900 tabular-nums text-sm" data-id="element-623">
              {item.quantity}
            </div>
            <div className="col-span-1 text-right text-neutral-900 tabular-nums text-sm" data-id="element-624">
              {formatCurrency(item.tax)}
            </div>
            <div className="col-span-1 text-right text-neutral-900 tabular-nums text-xs" data-id="element-625">
              {formatDiscount(item.discountAmount || 0, item.discountRate)}
            </div>
            <div className="col-span-2 text-right font-semibold text-neutral-900 tabular-nums text-sm" data-id="element-626">
              {formatCurrency(item.amount)}
            </div>
          </div>
        </div>)}
    </div>;
}